var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineArrowRight = function SvgLineArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.923 12.424.424-.424-.424-.424-6.3-6.3-.423-.423-.848.847.424.424 5.276 5.276H3.6v1.2h14.452l-5.276 5.276-.424.424.848.848.423-.424z"
  })));
};
export default SvgLineArrowRight;